import React from 'react';
import {SpinnerCircular} from 'spinners-react';
import cn from 'classnames';

interface LoadingSpinnerProps {
  isLoading: boolean;
  className?: string;
  size?: number;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  className,
  isLoading,
  size = 15,
}) => {
  if (!isLoading) return null;

  return <SpinnerCircular size={size} className={cn('loading-spinner', className)} />;
};
